require("core-js/modules/es.array.flat.js");
require("core-js/modules/es.array.unscopables.flat.js");
(function () {
  "use strict";

  var e = {
      n: function n(t) {
        var n = t && t.__esModule ? function () {
          return t.default;
        } : function () {
          return t;
        };
        return e.d(n, {
          a: n
        }), n;
      },
      d: function d(t, n) {
        for (var r in n) {
          e.o(n, r) && !e.o(t, r) && Object.defineProperty(t, r, {
            enumerable: !0,
            get: n[r]
          });
        }
      },
      o: function o(e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
      },
      r: function r(e) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
          value: "Module"
        }), Object.defineProperty(e, "__esModule", {
          value: !0
        });
      }
    },
    t = {};
  e.r(t), e.d(t, {
    FORM_FIELD_TYPES: function FORM_FIELD_TYPES() {
      return l;
    },
    FORM_VALIDATION_TYPES: function FORM_VALIDATION_TYPES() {
      return i;
    },
    Form: function Form() {
      return _e;
    },
    callEventsFromInputs: function callEventsFromInputs() {
      return d;
    },
    setChildrenFieldTouch: function setChildrenFieldTouch() {
      return Te;
    }
  });
  var n = require("react");
  var r = e.n(n);
  var o = require("formik"),
    a = require("@dls/web");
  var l = {
      TEXT_INPUT: "textInput",
      FORM_INPUT_AREA: "formInputArea",
      DROPDOWN_INPUT: "dropdown",
      BINARY_SELECTOR_INPUT: "binarySelector",
      DATE_PICKER_INPUT: "datePicker",
      CHECKBOX_INPUT: "checkbox",
      CHECKBOX_GROUP: "checkboxGroup",
      RADIO_GROUP: "radioGroup",
      FILE_UPLOAD: "fileUpload",
      READ_ONLY_LABEL: "readOnlyLabel",
      FORM_TEXT_LINK: "formTextLink",
      FORM_TITLE: "formTitle",
      FORM_DIVIDER: "divider",
      FORM_SPACING: "spacing",
      FORM_SUBMIT_BUTTON: "submitButton",
      FORM_GROUP_BUTTONS: "groupButtons",
      FORM_GROUP_SELECTORS: "FormGroupSelectors",
      FORM_GROUP_INPUTS: "groupInputs",
      EMPTY_FIELD: "empty",
      FORM_OBSERVER: "formObserver",
      FORM_CUSTOM_FIELD: "formCustomField",
      FORM_SWITCH: "formSwitch",
      FORM_FIELD_ARRAY: "formFieldArray"
    },
    i = {
      DOB_VALIDATION: "dobValidation",
      NRIC_FIN_VALIDATION: "nricFinValidation",
      CALLBACK_VALIDATION: "callbackValidation",
      MOBILE_NUM_VALIDATION: "mobileNumValidation",
      PATTERN_VALIDATION: "patternValidation",
      URL_VALIDATION: "urlValidation",
      MONEY_VALIDATION: "moneyValidation",
      ARRAY_OF_STRING_VALIDATION: "arrayOfStringValidation"
    };
  var c = require("yup"),
    u = require("date-fns");
  var _s = function s() {
      return _s = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }
        return e;
      }, _s.apply(this, arguments);
    },
    p = function p(e, t) {
      return void 0 === t && (t = {}), Object.keys(e).reduce(function (n, r) {
        return n[r] = t[e[r]], n;
      }, {});
    },
    d = function d(e, t, n) {
      var r = e[t];
      if (r) return r(n);
    },
    f = function f(e, t) {
      for (var n = (t = (t = t.replace(/\[(\w+)\]/g, ".$1")).replace(/^\./, "")).split("."), r = 0, o = n.length; r < o; ++r) {
        var a = n[r];
        if (!(a in e)) return;
        e = e[a];
      }
      return e;
    },
    _m = function m() {
      return _m = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }
        return e;
      }, _m.apply(this, arguments);
    },
    v = function v(e, t) {
      var n = {};
      for (var r in e) {
        Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
      }
      if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
        var o = 0;
        for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) {
          t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
        }
      }
      return n;
    };
  c.addMethod(c.string, i.DOB_VALIDATION, function (e, t) {
    return void 0 === t && (t = {}), this.test("dob-validation", e, function (n, r) {
      if (!n) return !0;
      var o = r.createError,
        a = r.path,
        l = t.format,
        i = void 0 === l ? "dd/MM/yyyy" : l,
        c = t.limit,
        s = t.limitUnderage,
        p = t.limitAtToday,
        d = void 0 !== p && p,
        f = (0, u.isValid)((0, u.parse)(n.replace(/ /g, ""), i, new Date()));
      return c && (f = (0, u.parse)(n.replace(/ /g, ""), i, new Date()).getFullYear() >= c), d && (f = f && (0, u.isBefore)((0, u.parse)(n.replace(/ /g, ""), i, new Date()), new Date())), s && (f = f && (0, u.isBefore)((0, u.parse)(n.replace(/ /g, ""), i, new Date()), (0, u.subYears)(new Date(), s))), f || o({
        path: a,
        message: e
      });
    });
  }), c.addMethod(c.string, i.NRIC_FIN_VALIDATION, function (e, t) {
    return void 0 === t && (t = {}), this.test("nric-fin-validation", e, function (n, r) {
      if (!n) return null;
      var o = r.createError,
        a = r.path,
        l = r.parent,
        i = t.field,
        c = t.value,
        u = n.match(new RegExp("[ST]\\d{7}[A-Z]$")),
        s = n.match(new RegExp("[FGHM]\\d{7}[A-Z]$")),
        p = l[i] === c;
      return !!u || (p ? !!u : !!s) || o({
        path: a,
        message: e
      });
    });
  }), c.addMethod(c.string, i.URL_VALIDATION, function (e, t) {
    return void 0 === t && (t = {}), this.test("url-validation", e, function (t, n) {
      if (!t) return null;
      var r = n.createError,
        o = n.path;
      return new RegExp(/((http|https|ftp):\/\/[\w?=&.\/-;#~%-]+(?![\w\s?&.\/;#~%"=-]*>))/g).test(t) || r({
        path: o,
        message: e
      });
    });
  }), c.addMethod(c.string, i.MONEY_VALIDATION, function (e, t) {
    return void 0 === t && (t = {}), this.test("money-validation", e, function (n, r) {
      if (!n) return null;
      var o = t.minDecimalPlaces,
        a = void 0 === o ? 0 : o,
        l = t.maxDecimalPlaces,
        i = void 0 === l ? 2 : l,
        c = r.createError,
        u = r.path;
      return new RegExp("^(?!0\\d)\\d+(\\.\\d{".concat(a, ",").concat(i, "})?$")).test(n) || c({
        path: u,
        message: e
      });
    });
  }), c.addMethod(c.mixed, i.CALLBACK_VALIDATION, function (e, t) {
    var n = this;
    return void 0 === t && (t = {}), this.test("callback-validation", e, function (e, r) {
      return o = n, a = void 0, i = function i() {
        var n, o, a, l, i, c, u, s, p, d, y, O, b, g, h, E, P, x, I, w, F, j, C;
        return function (e, t) {
          var n,
            r,
            o,
            a,
            l = {
              label: 0,
              sent: function sent() {
                if (1 & o[0]) throw o[1];
                return o[1];
              },
              trys: [],
              ops: []
            };
          return a = {
            next: i(0),
            throw: i(1),
            return: i(2)
          }, "function" == typeof Symbol && (a[Symbol.iterator] = function () {
            return this;
          }), a;
          function i(a) {
            return function (i) {
              return function (a) {
                if (n) throw new TypeError("Generator is already executing.");
                for (; l;) {
                  try {
                    if (n = 1, r && (o = 2 & a[0] ? r.return : a[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, a[1])).done) return o;
                    switch (r = 0, o && (a = [2 & a[0], o.value]), a[0]) {
                      case 0:
                      case 1:
                        o = a;
                        break;
                      case 4:
                        return l.label++, {
                          value: a[1],
                          done: !1
                        };
                      case 5:
                        l.label++, r = a[1], a = [0];
                        continue;
                      case 7:
                        a = l.ops.pop(), l.trys.pop();
                        continue;
                      default:
                        if (!((o = (o = l.trys).length > 0 && o[o.length - 1]) || 6 !== a[0] && 2 !== a[0])) {
                          l = 0;
                          continue;
                        }
                        if (3 === a[0] && (!o || a[1] > o[0] && a[1] < o[3])) {
                          l.label = a[1];
                          break;
                        }
                        if (6 === a[0] && l.label < o[1]) {
                          l.label = o[1], o = a;
                          break;
                        }
                        if (o && l.label < o[2]) {
                          l.label = o[2], l.ops.push(a);
                          break;
                        }
                        o[2] && l.ops.pop(), l.trys.pop();
                        continue;
                    }
                    a = t.call(e, l);
                  } catch (e) {
                    a = [6, e], r = 0;
                  } finally {
                    n = o = 0;
                  }
                }
                if (5 & a[0]) throw a[1];
                return {
                  value: a[0] ? a[1] : void 0,
                  done: !0
                };
              }([a, i]);
            };
          }
        }(this, function (k) {
          switch (k.label) {
            case 0:
              return n = r.createError, o = r.path, v(r, ["createError", "path"]), a = t.callbacks, l = void 0 === a ? {} : a, i = t.name, c = t.promise, u = t.values, s = void 0 === u ? {} : u, p = t.errors, d = void 0 === p ? {} : p, y = t.formikContext, O = void 0 === y ? {} : y, b = t.isErrorResetRequired, g = void 0 !== b && b, h = O.setErrors, E = f(s, o), P = f(null == r ? void 0 : r.parent, o), x = l[i], I = {
                name: o,
                values: s,
                errors: d,
                formikContext: O
              }, g && h(_m(_m({}, d), ((C = {})[o] = null, C))), e && x ? E === P ? [3, 4] : c ? [4, x(e, I)] : [3, 2] : [2, !0];
            case 1:
              return F = k.sent(), [3, 3];
            case 2:
              F = x(e, I), k.label = 3;
            case 3:
              return j = (w = F).message, [2, !!w.valid || n({
                path: o,
                message: j
              })];
            case 4:
              return [2, !d[o] || n({
                path: o,
                message: d[o]
              })];
          }
        });
      }, new ((l = void 0) || (l = Promise))(function (e, t) {
        function n(e) {
          try {
            c(i.next(e));
          } catch (e) {
            t(e);
          }
        }
        function r(e) {
          try {
            c(i.throw(e));
          } catch (e) {
            t(e);
          }
        }
        function c(t) {
          var o;
          t.done ? e(t.value) : (o = t.value, o instanceof l ? o : new l(function (e) {
            e(o);
          })).then(n, r);
        }
        c((i = i.apply(o, a || [])).next());
      });
      var o, a, l, i;
    });
  }), c.addMethod(c.string, i.MOBILE_NUM_VALIDATION, function (e, t) {
    return void 0 === t && (t = {}), this.test("mobile-num-validation", e, function (n, r) {
      var o, a;
      if (!n) return null;
      var l = (null === (a = null === (o = null == n ? void 0 : n.replace("+65 ", "")) || void 0 === o ? void 0 : o.split(" ")) || void 0 === a ? void 0 : a.join("")) || n,
        i = r.createError,
        c = r.path,
        u = t.regExp,
        s = void 0 === u ? "(8|9)\\d{7}" : u,
        p = t.inValidLengthMsg,
        d = void 0 === p ? "Enter a valid 8-digit mobile number" : p,
        f = new RegExp(s).test(l);
      return 8 !== l.length ? i({
        path: c,
        message: d
      }) : f || i({
        path: c,
        message: e
      });
    });
  }), c.addMethod(c.string, i.PATTERN_VALIDATION, function (e, t) {
    return void 0 === t && (t = {}), this.test("pattern-validation", e, function (e, n) {
      if (!e) return null;
      var r = n.createError,
        o = n.path,
        a = t.regPattern,
        l = void 0 === a ? "/^$/" : a,
        i = t.invalidMessage,
        c = void 0 === i ? "Enter a valid value" : i;
      return new RegExp(l).test(e) || r({
        path: o,
        message: c
      });
    });
  });
  var y = function y(e) {
      return e.map(function (e) {
        return e.component === l.FORM_GROUP_INPUTS ? y(e.groupElements) : e;
      }).flat(1);
    },
    O = function O(e, t, n, r, o, a) {
      var i = y(e).reduce(function (e, i) {
        var u,
          s,
          p = i.name,
          d = i.component,
          f = i.groupElements,
          y = i.validations,
          b = void 0 === y ? [] : y;
        if (d === l.FORM_FIELD_ARRAY) {
          var g = t ? t.pick(p) : void 0,
            h = O(f, g, n, r, o, a);
          if (h) return _m(_m({}, e), ((u = {})[p] = c.array().of(h), u));
        }
        var E = function (e, t, n, r, o) {
          return Array.isArray(e) && e.length ? e.reduce(function (e, a) {
            if ("string" == typeof a) return e[a]();
            if (a instanceof Object) {
              var l = a.type,
                i = a.params || {},
                c = i.message,
                u = v(i, ["message"]);
              return e[l](c, _m(_m({
                callbacks: t
              }, u), {
                values: n,
                errors: r,
                formikContext: o
              }));
            }
          }, c) : null;
        }(b, n, r, o, a);
        return E ? _m(_m({}, e), ((s = {})[p] = E, s)) : e;
      }, {});
      return c.object().shape(i).concat(t);
    };
  var b = require("@dls/assets/dist/icons/web"),
    g = require("styled-components");
  var h,
    E,
    P,
    x,
    I,
    w = e.n(g),
    F = function F(e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    },
    j = w().div(h || (h = F(["\n  cursor: pointer;\n"], ["\n  cursor: pointer;\n"]))),
    C = w()(a.Row)(E || (E = F(["\n  margin-left: -8px;\n  margin-right: -8px;\n  margin-bottom: -8px;\n"], ["\n  margin-left: -8px;\n  margin-right: -8px;\n  margin-bottom: -8px;\n"]))),
    k = w()(a.Row)(P || (P = F(["\n  align-items: center;\n"], ["\n  align-items: center;\n"]))),
    _ = w().div(I || (I = F(["\n  ", "\n"], ["\n  ", "\n"])), function (e) {
      return e.flex && (0, g.css)(x || (x = F(["\n      display: flex;\n      align-items: ", ";\n      justify-content: ", ";\n    "], ["\n      display: flex;\n      align-items: ", ";\n      justify-content: ", ";\n    "])), e.alignItems || "flex-start", e.justifyContent || "flex-start");
    }),
    _T = function T() {
      return _T = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }
        return e;
      }, _T.apply(this, arguments);
    },
    S = function S(e, t) {
      var n = {};
      for (var r in e) {
        Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
      }
      if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
        var o = 0;
        for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) {
          t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
        }
      }
      return n;
    };
  var _R = function R() {
    return _R = Object.assign || function (e) {
      for (var t, n = 1, r = arguments.length; n < r; n++) {
        for (var o in t = arguments[n]) {
          Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        }
      }
      return e;
    }, _R.apply(this, arguments);
  };
  var M,
    L,
    A = (0, a.withTheme)(w().div(V || (M = ["\n  color: #bc1430;\n  font-size: 16px;\n  flex: 0 0 85%;\n  margin: ", ";\n"], L = ["\n  color: #bc1430;\n  font-size: 16px;\n  flex: 0 0 85%;\n  margin: ", ";\n"], Object.defineProperty ? Object.defineProperty(M, "raw", {
      value: L
    }) : M.raw = L, V = M), function (e) {
      var t = e.coreTheme;
      return "".concat(t.space_0, "px ").concat(t.space_0, "px ").concat(t.space_0, "px ").concat(t.space_0, "px");
    }));
  var D = A;
  var V,
    _N = function N() {
      return _N = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }
        return e;
      }, _N.apply(this, arguments);
    };
  var _B = function B() {
    return _B = Object.assign || function (e) {
      for (var t, n = 1, r = arguments.length; n < r; n++) {
        for (var o in t = arguments[n]) {
          Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        }
      }
      return e;
    }, _B.apply(this, arguments);
  };
  var _U = function U() {
    return _U = Object.assign || function (e) {
      for (var t, n = 1, r = arguments.length; n < r; n++) {
        for (var o in t = arguments[n]) {
          Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        }
      }
      return e;
    }, _U.apply(this, arguments);
  };
  var _G = function G() {
    return _G = Object.assign || function (e) {
      for (var t, n = 1, r = arguments.length; n < r; n++) {
        for (var o in t = arguments[n]) {
          Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        }
      }
      return e;
    }, _G.apply(this, arguments);
  };
  var _Y = function Y() {
    return _Y = Object.assign || function (e) {
      for (var t, n = 1, r = arguments.length; n < r; n++) {
        for (var o in t = arguments[n]) {
          Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        }
      }
      return e;
    }, _Y.apply(this, arguments);
  };
  var _z = function z() {
    return _z = Object.assign || function (e) {
      for (var t, n = 1, r = arguments.length; n < r; n++) {
        for (var o in t = arguments[n]) {
          Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        }
      }
      return e;
    }, _z.apply(this, arguments);
  };
  var _K = function K() {
    return _K = Object.assign || function (e) {
      for (var t, n = 1, r = arguments.length; n < r; n++) {
        for (var o in t = arguments[n]) {
          Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        }
      }
      return e;
    }, _K.apply(this, arguments);
  };
  var q = function q(e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    },
    _W = function W() {
      return _W = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }
        return e;
      }, _W.apply(this, arguments);
    },
    X = w()(a.Column)($ || ($ = q(["\n  ", "\n"], ["\n  ", "\n"])), function (e) {
      var t = e.noGutterTop,
        n = e.noGutterRight,
        r = e.noGutterLeft,
        o = e.noGutterBottom;
      return (0, g.css)(H || (H = q(["\n      ", "\n\n      ", "\n\n      ", "\n      \n      ", "\n    "], ["\n      ", "\n\n      ", "\n\n      ", "\n      \n      ", "\n    "])), t && "\n        padding-top: 0px;\n      ", n && "\n        padding-right: 0px;\n      ", r && "\n        padding-left: 0px;\n      ", o && "\n        padding-bottom 0px;\n      ");
    });
  var H,
    $,
    _Z = function Z() {
      return _Z = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }
        return e;
      }, _Z.apply(this, arguments);
    };
  var J = function J(e) {
    var t = e.enableInputErrorFocus,
      r = void 0 !== t && t,
      a = e.onChange,
      l = e.valuesOnDemand,
      i = void 0 === l ? [] : l,
      c = e.errorsOnDemand,
      u = (0, o.useFormikContext)(),
      s = u.values,
      p = u.setFormikState,
      d = u.errors,
      f = u.isValid,
      m = u.submitCount,
      v = u.setFieldValue,
      y = u.setFieldError,
      O = u.setTouched,
      b = u.setFieldTouched,
      g = (0, n.useState)(s),
      h = g[0],
      E = g[1],
      P = (0, n.useState)(m),
      x = P[0],
      I = P[1];
    return (0, n.useEffect)(function () {
      i && i.forEach(function (e) {
        var t = e.field,
          n = e.value,
          r = e.shouldValidate;
        v(t, n, r);
      });
    }, [i]), (0, n.useEffect)(function () {
      c && (Object.keys(c).length < 1 && O({}, !1), Object.entries(c).forEach(function (e) {
        var t = e[0],
          n = e[1];
        b(t, !0, !1), y(t, n);
      }));
    }, [c]), (0, n.useEffect)(function () {
      p(function (e) {
        return E(e.values), e;
      }), a({
        values: s,
        prevValues: h,
        errors: d,
        formikContext: u
      });
    }, [s, h, d]), (0, n.useEffect)(function () {
      var e;
      if (r && !f && m > x) for (var t in d) {
        var n = global.window.document,
          o = null == n ? void 0 : n.getElementsByName(t),
          a = null == n ? void 0 : n.getElementById(t);
        if (o.length) {
          null === (e = o[0]) || void 0 === e || e.focus(), I(m);
          break;
        }
        if (a) {
          null == a || a.focus(), I(m);
          break;
        }
      }
    }, [x, m, f, d]), null;
  };
  var _Q = function Q() {
    return _Q = Object.assign || function (e) {
      for (var t, n = 1, r = arguments.length; n < r; n++) {
        for (var o in t = arguments[n]) {
          Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        }
      }
      return e;
    }, _Q.apply(this, arguments);
  };
  var _ee = function ee() {
    return _ee = Object.assign || function (e) {
      for (var t, n = 1, r = arguments.length; n < r; n++) {
        for (var o in t = arguments[n]) {
          Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        }
      }
      return e;
    }, _ee.apply(this, arguments);
  };
  var te = function te(e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    },
    _ne = function ne() {
      return _ne = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }
        return e;
      }, _ne.apply(this, arguments);
    },
    re = w()(a.Column)(ae || (ae = te(["\n  ", "\n"], ["\n  ", "\n"])), function (e) {
      var t = e.noGutterTop,
        n = e.noGutterRight,
        r = e.noGutterLeft,
        o = e.noGutterBottom;
      return (0, g.css)(oe || (oe = te(["\n      ", "\n\n      ", "\n\n      ", "\n      \n      ", "\n    "], ["\n      ", "\n\n      ", "\n\n      ", "\n      \n      ", "\n    "])), t && "\n        padding-top: 0px;\n      ", n && "\n        padding-right: 0px;\n      ", r && "\n        padding-left: 0px;\n      ", o && "\n        padding-bottom 0px;\n      ");
    });
  var oe,
    ae,
    _le = function le() {
      return _le = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }
        return e;
      }, _le.apply(this, arguments);
    };
  var ie = function ie(e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    },
    _ce = function ce() {
      return _ce = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }
        return e;
      }, _ce.apply(this, arguments);
    },
    ue = function ue(e, t) {
      var n = {};
      for (var r in e) {
        Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
      }
      if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
        var o = 0;
        for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) {
          t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
        }
      }
      return n;
    },
    se = {
      white: a.theme.main.colours.white,
      haze: a.theme.main.colours.tertiary.l6,
      transparent: "transparent"
    },
    pe = w()(a.Column)(ve || (ve = ie(["\n  ", "\n"], ["\n  ", "\n"])), function (e) {
      var t = e.noGutterTop,
        n = e.noGutterRight,
        r = e.noGutterLeft,
        o = e.noGutterBottom;
      return (0, g.css)(me || (me = ie(["\n      ", "\n\n      ", "\n\n      ", "\n      \n      ", "\n    "], ["\n      ", "\n\n      ", "\n\n      ", "\n      \n      ", "\n    "])), t && "\n        padding-top: 0px;\n      ", n && "\n        padding-right: 0px;\n      ", r && "\n        padding-left: 0px;\n      ", o && "\n        padding-bottom 0px;\n      ");
    }),
    de = w()(C)(Oe || (Oe = ie(["\n  width: 100%;\n  margin: 0;\n  ", "\n"], ["\n  width: 100%;\n  margin: 0;\n  ", "\n"])), function (e) {
      var t = e.bgColor,
        n = e.borderRadius,
        r = e.alignItems;
      return (0, g.css)(ye || (ye = ie(["\n      ", "\n\n      ", "\n      display: flex;\n      align-items: ", ";\n    "], ["\n      ", "\n\n      ", "\n      display: flex;\n      align-items: ", ";\n    "])), t && "\n        background-color: ".concat(se[t], ";\n        padding: 0.5rem;\n\n      "), n && "\n        border-radius: ".concat(a.theme.borderRadius[n], ";\n      "), r);
    });
  var fe = function fe(e) {
    var t = e.data,
      n = e.callbacks,
      o = e.rowProps,
      a = e.alignItems,
      l = void 0 === a ? "flex-start" : a,
      i = e.groupElements,
      c = void 0 === i ? [] : i,
      u = e.keyIndex,
      s = (e.columnProps, e.layoutProps),
      p = ue(e, ["data", "callbacks", "rowProps", "alignItems", "groupElements", "keyIndex", "columnProps", "layoutProps"]);
    return Array.isArray(c) && c.length ? r().createElement(de, _ce({
      key: u,
      middle: "xs",
      alignItems: l
    }, o, s), c.map(function (e, o) {
      var a = e.columnProps,
        l = ue(e, ["columnProps"]);
      return r().createElement(pe, _ce({
        "data-id": "group-column-".concat(l.name, "-").concat(o),
        key: "group-column-".concat(l.name, "-").concat(o)
      }, a), r().createElement(ke, _ce({
        data: t,
        callbacks: n
      }, p, l)));
    })) : null;
  };
  var me,
    ve,
    ye,
    Oe,
    _be = function be() {
      return _be = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }
        return e;
      }, _be.apply(this, arguments);
    },
    ge = function ge(e, t) {
      var n = {};
      for (var r in e) {
        Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
      }
      if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
        var o = 0;
        for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) {
          t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
        }
      }
      return n;
    },
    he = function he(e) {
      var t = e.type,
        n = void 0 === t ? "card" : t,
        o = e.keyIndex,
        l = void 0 === o ? "" : o,
        i = e.children;
      return "card" === n ? r().createElement(a.Card, {
        shadow: "sm",
        radius: "sm",
        padding: "sm",
        key: l
      }, r().createElement(a.Card.Content, null, i)) : r().createElement(r().Fragment, null, i);
    },
    Ee = function Ee(e) {
      var t = e.config,
        n = e.parentIndex,
        r = e.parentFieldName;
      return t.map(function (e) {
        var t = e.groupElements,
          o = ge(e, ["groupElements"]);
        return t ? _be(_be({}, o), {
          groupElements: Ee({
            config: t,
            parentIndex: n,
            parentFieldName: r
          })
        }) : _be(_be({}, e), {
          name: "".concat(r, ".").concat(n, ".").concat(e.name)
        });
      });
    },
    Pe = w().div(xe || (xe = function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    }(["\n  > div [class*='style__Content'] {\n    padding-top: 0px;\n    padding-bottom: 0px;\n  }\n\n  > [class*='style__CardContainer'] {\n    margin-bottom: 1rem;\n  }\n"], ["\n  > div [class*='style__Content'] {\n    padding-top: 0px;\n    padding-bottom: 0px;\n  }\n\n  > [class*='style__CardContainer'] {\n    margin-bottom: 1rem;\n  }\n"])));
  var xe,
    _Ie = function Ie() {
      return _Ie = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }
        return e;
      }, _Ie.apply(this, arguments);
    },
    we = function we(e, t) {
      var n = {};
      for (var r in e) {
        Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
      }
      if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
        var o = 0;
        for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) {
          t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
        }
      }
      return n;
    };
  var Fe;
  var je = ((Fe = {})[l.TEXT_INPUT] = function (e) {
    var t = e.label,
      n = e.hintMessage,
      l = e.textTransform,
      i = e.callbacks,
      c = e.events,
      u = void 0 === c ? {} : c,
      s = e.validateOnChange,
      f = void 0 !== s && s,
      m = e.dynamicFieldProps,
      v = void 0 === m ? {} : m,
      y = S(e, ["label", "hintMessage", "textTransform", "callbacks", "events", "validateOnChange", "dynamicFieldProps"]),
      O = (0, o.useFormikContext)(),
      g = (0, o.useField)(y),
      h = g[0],
      E = g[1],
      P = g[2],
      x = P.setValue,
      I = P.setTouched,
      w = null,
      F = v[y.name] || {};
    if (y.rightTextLink) {
      var C = y.rightTextLink,
        k = C.text,
        _ = C.events,
        R = p(_, i);
      w = _T({
        text: k
      }, R);
    }
    var M = p(u, i),
      L = M.onChange,
      A = S(M, ["onChange"]);
    return r().createElement(a.TextInput, _T({}, h, y, A, F, {
      rightTextLink: w,
      suffix: function () {
        if (!y.rightIconLink) return null;
        var e = y.rightIconLink,
          t = e.iconName,
          n = e.iconSize,
          o = e.events,
          l = p(o, i);
        return r().createElement(j, {
          onClick: function onClick() {
            E.error || !h.value ? I(!0) : l.onClick && l.onClick(h.value, O.setFieldValue, y.name);
          },
          "data-testid": "".concat(y.name, "-input-right-icon")
        }, r().createElement(b.Icon, {
          name: t,
          size: n,
          color: a.theme.main.colours.secondary.d1
        }));
      }(),
      label: t,
      error: E.touched && E.error,
      hintMessage: E.touched && E.error || n,
      onChange: function onChange(e) {
        f && I(!0), L ? L(e) : e.target.value;
        var t = l ? function (e, t) {
          switch (t) {
            case "capitalize":
              return null == e ? void 0 : e.replace(/(^\w{1})|(\s+\w{1})/g, function (e) {
                return e.toUpperCase();
              });
            case "uppercase":
              return null == e ? void 0 : e.toUpperCase();
            case "lowercase":
              return null == e ? void 0 : e.toLowerCase();
            default:
              return e;
          }
        }(e.target.value, l) : e.target.value;
        x(t), d(A, "onValueChange", {
          name: y.name,
          value: t,
          setFieldValue: O.setFieldValue,
          formikContext: O
        });
      }
    }));
  }, Fe[l.FORM_INPUT_AREA] = function (e) {
    e.form;
    var t = e.label,
      n = e.bgColor,
      l = e.maxLength,
      i = e.hintMessage,
      c = e.placeholder,
      u = e.events,
      s = void 0 === u ? {} : u,
      f = e.callbacks,
      m = we(e, ["form", "label", "bgColor", "maxLength", "hintMessage", "placeholder", "events", "callbacks"]),
      v = (0, o.useFormikContext)(),
      y = (0, o.useField)(m),
      O = y[0],
      b = y[1],
      g = y[2],
      h = g.setValue,
      E = g.setTouched,
      P = p(s, f),
      x = P.onChange,
      I = we(P, ["onChange"]);
    return r().createElement(a.TextAreaInput, _Ie({
      id: "default-textarea",
      label: t,
      bgColor: n,
      maxLength: l,
      hintMessage: b.touched && b.error || i,
      placeholder: c
    }, O, m, {
      error: b.touched && b.error,
      onChange: function onChange(e) {
        E(!0);
        var t = x ? x(e) : e.target.value;
        h(t), d(I, "onValueChange", {
          name: m.name,
          value: e.target.value,
          setFieldValue: v.setFieldValue,
          formikContext: v
        });
      },
      onBlur: function onBlur() {
        E(!0);
      }
    }));
  }, Fe[l.DROPDOWN_INPUT] = function (e) {
    var t = e.events,
      n = void 0 === t ? {} : t,
      l = e.label,
      i = (e.hintMessage, e.callbacks),
      c = function (e, t) {
        var n = {};
        for (var r in e) {
          Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
        }
        if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
          var o = 0;
          for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) {
            t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
          }
        }
        return n;
      }(e, ["events", "label", "hintMessage", "callbacks"]),
      u = (0, o.useFormikContext)(),
      s = (0, o.useField)(c),
      f = s[0],
      m = s[1],
      v = s[2],
      y = c.name,
      O = c.source,
      b = v.setValue,
      g = p(n, i),
      h = _R(_R(_R(_R({}, f), c), {
        label: l,
        key: y,
        id: l,
        items: O,
        error: m.touched && m.error,
        hintMessage: m.touched && m.error,
        onChange: function onChange(e) {
          b(e.value), d(g, "onDropDownChange", {
            name: c.name,
            value: e.value,
            setFieldValue: u.setFieldValue,
            formikContext: u
          });
        }
      }), g);
    return r().createElement(a.DropdownInput, _R({}, h));
  }, Fe[l.BINARY_SELECTOR_INPUT] = function (e) {
    var t = e.label,
      n = e.events,
      l = void 0 === n ? {} : n,
      i = e.callbacks,
      c = void 0 === i ? {} : i,
      u = function (e, t) {
        var n = {};
        for (var r in e) {
          Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
        }
        if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
          var o = 0;
          for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) {
            t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
          }
        }
        return n;
      }(e, ["label", "events", "callbacks"]),
      s = (0, o.useField)(u),
      f = s[0],
      m = s[1],
      v = s[2],
      y = u.name,
      O = u.source,
      b = v.setValue,
      g = O[0],
      h = O[1],
      E = p(l, c),
      P = (0, o.useFormikContext)(),
      x = _N(_N(_N({}, f), u), {
        label: t,
        key: y,
        id: t,
        firstOption: g,
        secondOption: h,
        error: m.touched && m.error,
        hintMessage: m.touched && m.error,
        onChange: function onChange(e, t) {
          b(t.value), d(E, "onBinaryChange", {
            name: y,
            value: t.value,
            setFieldValue: P.setFieldValue,
            formikContext: P
          });
        }
      });
    return r().createElement(r().Fragment, null, r().createElement(a.BinarySelector, _N({}, x)), x.error ? r().createElement(D, null, x.error) : null);
  }, Fe[l.DATE_PICKER_INPUT] = function (e) {
    var t = e.label,
      n = e.hintMessage,
      l = function (e, t) {
        var n = {};
        for (var r in e) {
          Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
        }
        if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
          var o = 0;
          for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) {
            t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
          }
        }
        return n;
      }(e, ["label", "hintMessage"]),
      i = (0, o.useField)(l),
      c = i[0],
      u = i[1],
      s = i[2],
      p = u.value,
      d = s.setValue;
    return r().createElement(a.DatePicker.SingleDatePicker, _B({}, c, {
      id: t,
      label: t,
      value: p,
      formatter: a.DatePicker.dateFormats["dd / MM / yyyy"],
      error: u.touched && u.error,
      hintMessage: u.touched && u.error || n,
      onChange: function onChange(e) {
        d(e);
      }
    }, l));
  }, Fe[l.CHECKBOX_INPUT] = function (e) {
    var t = e.label,
      n = (e.hintMessage, e.showError),
      l = e.events,
      i = void 0 === l ? {} : l,
      c = e.callbacks,
      u = void 0 === c ? {} : c,
      s = function (e, t) {
        var n = {};
        for (var r in e) {
          Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
        }
        if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
          var o = 0;
          for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) {
            t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
          }
        }
        return n;
      }(e, ["label", "hintMessage", "showError", "events", "callbacks"]),
      f = (0, o.useFormikContext)(),
      m = s.name,
      v = p(i, u),
      y = (0, o.useField)(s),
      O = y[0],
      b = y[1],
      g = y[2].setValue,
      h = _U(_U({}, O), {
        checked: O.value
      });
    return r().createElement(r().Fragment, null, r().createElement(a.Checkbox.Input, _U({}, h, s, {
      key: m,
      label: t,
      error: b.touched && b.error,
      onChange: function onChange(e, t) {
        g(t), d(v, "onSelectionChange", {
          name: m,
          value: t,
          setFieldValue: f.setFieldValue,
          formikContext: f
        });
      }
    })), n && b.touched && b.error ? r().createElement(a.Spacing, {
      topBottom: 1
    }, r().createElement(D, null, b.error)) : null);
  }, Fe[l.CHECKBOX_GROUP] = function (e) {
    var t = e.columnProps,
      n = void 0 === t ? {
        xs: 12
      } : t,
      l = e.titleType,
      i = void 0 === l ? "header" : l,
      c = e.title,
      u = e.events,
      s = void 0 === u ? {} : u,
      f = e.callbacks,
      m = void 0 === f ? {} : f,
      v = function (e, t) {
        var n = {};
        for (var r in e) {
          Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
        }
        if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
          var o = 0;
          for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) {
            t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
          }
        }
        return n;
      }(e, ["columnProps", "titleType", "title", "events", "callbacks"]),
      y = (0, o.useFormikContext)(),
      O = v.name,
      b = v.source,
      g = void 0 === b ? [] : b,
      h = v.isVertical,
      E = void 0 === h || h,
      P = p(s, m),
      x = (0, o.useField)(v),
      I = x[0],
      w = x[1],
      F = E ? a.Stack : a.Inline;
    return r().createElement(o.FieldArray, {
      name: O
    }, function (e) {
      return r().createElement(a.Checkbox.InputGroup, {
        error: w.touched ? w.error : ""
      }, c && r().createElement(a.Spacing, {
        topBottom: 1
      }, r().createElement(a.Text, {
        type: i
      }, c)), r().createElement(F, {
        space: 2
      }, g.map(function (t) {
        var o;
        return r().createElement(a.Column, _G({}, n), r().createElement(a.Checkbox.Input, _G({}, v, {
          checked: null === (o = I.value) || void 0 === o ? void 0 : o.includes(t.value),
          key: t.value,
          label: t.label,
          error: w.touched && w.error,
          onChange: function onChange(n, r) {
            if (r) e.push(t.value);else {
              var o = I.value.indexOf(t.value);
              e.remove(o);
            }
            d(P, "onGroupSelectionChange", {
              name: O,
              option: t,
              value: r,
              setFieldValue: y.setFieldValue,
              formikContext: y
            });
          }
        })));
      })));
    });
  }, Fe[l.RADIO_GROUP] = function (e) {
    var t = e.columnProps,
      n = e.titleType,
      l = e.title,
      i = e.events,
      c = void 0 === i ? {} : i,
      u = e.callbacks,
      s = void 0 === u ? {} : u,
      f = e.label,
      m = function (e, t) {
        var n = {};
        for (var r in e) {
          Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
        }
        if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
          var o = 0;
          for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) {
            t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
          }
        }
        return n;
      }(e, ["columnProps", "titleType", "title", "events", "callbacks", "label"]),
      v = (0, o.useField)(m),
      y = v[0],
      O = v[1],
      b = v[2],
      g = m.name,
      h = m.source,
      E = b.setValue,
      P = p(c, s),
      x = (0, o.useFormikContext)(),
      I = _Y(_Y(_Y({}, y), m), {
        key: g,
        label: f,
        error: O.touched && O.error,
        hintMessage: O.touched && O.error,
        onChange: function onChange(e) {
          E(e.value), d(P, "onRadioChange", {
            name: g,
            value: e.value,
            setFieldValue: x.setFieldValue,
            formikContext: x
          });
        }
      });
    return r().createElement(r().Fragment, null, r().createElement(a.Text, {
      type: n
    }, l), r().createElement(C, null, h.map(function (e) {
      return r().createElement(a.Column, _Y({}, t), r().createElement(a.Radio.Input, _Y({}, I, {
        onChange: function onChange(t, n) {
          n && I.onChange && I.onChange(e);
        },
        key: e.id,
        value: e.value,
        checked: e.value === I.value
      }), e.label));
    })), I.error && r().createElement(D, null, I.error));
  }, Fe[l.FILE_UPLOAD] = function (e) {
    var t = e.callbacks,
      l = e.label,
      i = e.events,
      c = void 0 === i ? {} : i,
      u = function (e, t) {
        var n = {};
        for (var r in e) {
          Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
        }
        if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
          var o = 0;
          for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) {
            t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
          }
        }
        return n;
      }(e, ["callbacks", "label", "events"]),
      s = p(c, t),
      d = u.name,
      f = u.isError,
      m = u.errorMessage,
      v = u.isPreloaded,
      y = void 0 !== v && v,
      O = (0, n.useState)(),
      b = O[0],
      g = O[1],
      h = (0, n.useState)(null),
      E = h[0],
      P = h[1],
      x = (0, n.useCallback)(function (e, t) {
        var n = s[e];
        n && n(t);
      }, [s]);
    return (0, n.useEffect)(function () {
      !b && E && x("onDrop", E);
    }, [b, E]), r().createElement(n.Fragment, null, r().createElement(o.Field, {
      name: d,
      id: d,
      type: "file"
    }, function (e) {
      var t = e.form,
        n = e.meta,
        o = e.field;
      return g(null == n ? void 0 : n.error), r().createElement("div", {
        className: "fs-exclude"
      }, r().createElement(a.FileInput, {
        title: l
      }, r().createElement(a.FileInput.DropZone, _ee({}, u, s, {
        isError: !(!n.error && !f),
        errorMessage: n.error ? "" : m,
        onDrop: function onDrop(e) {
          t.setFieldTouched(d, !0), t.setFieldValue(d, e[0]), P(e[0]);
        },
        singleModeOnDelete: function singleModeOnDelete() {
          var e;
          t.setFieldValue(d, null), x("singleModeOnDelete", null === (e = o.value) || void 0 === e ? void 0 : e.name);
        },
        singleModePreloadedFile: y ? o.value : null
      }))), n.touched && n.error ? r().createElement(a.Spacing, {
        topBottom: 1
      }, r().createElement(D, null, n.error)) : null);
    }));
  }, Fe[l.READ_ONLY_LABEL] = function (e) {
    var t = e.label,
      n = e.valueLabel;
    return r().createElement(a.Layout.Stack, null, r().createElement(a.Text, {
      type: "smallBody"
    }, t), r().createElement(a.Text, {
      type: "body"
    }, n));
  }, Fe[l.FORM_TEXT_LINK] = function (e) {
    var t = e.callbacks,
      n = e.label,
      o = e.events,
      l = p(void 0 === o ? {} : o, t);
    return r().createElement(a.TextLink, _Q({}, l), n);
  }, Fe[l.FORM_TITLE] = function (e) {
    var t = e.title,
      n = e.subTitle,
      o = e.titleType,
      l = void 0 === o ? "header" : o,
      i = function (e, t) {
        var n = {};
        for (var r in e) {
          Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
        }
        if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
          var o = 0;
          for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) {
            t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
          }
        }
        return n;
      }(e, ["title", "subTitle", "titleType"]);
    return r().createElement(a.Spacing, _z({}, i), r().createElement(a.Text, {
      type: l
    }, t), n && r().createElement(a.Text, null, n));
  }, Fe[l.FORM_DIVIDER] = function (e) {
    var t = e.sizing,
      n = void 0 === t ? 3 : t;
    return r().createElement(a.Spacing, {
      topBottom: n
    }, r().createElement(a.Divider, null));
  }, Fe[l.FORM_SPACING] = function (e) {
    var t = e.sizing,
      n = void 0 === t ? 1 : t;
    return r().createElement(a.Spacing, {
      topBottom: n
    });
  }, Fe[l.FORM_SUBMIT_BUTTON] = function (e) {
    var t = e.label,
      n = e.name,
      o = function (e, t) {
        var n = {};
        for (var r in e) {
          Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
        }
        if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
          var o = 0;
          for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) {
            t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
          }
        }
        return n;
      }(e, ["label", "name"]),
      l = o.btnProps,
      i = void 0 === l ? {} : l,
      c = o.rowProps,
      u = void 0 === c ? {} : c,
      s = o.columnProps,
      p = void 0 === s ? {} : s;
    return r().createElement(a.Row, _K({
      key: n
    }, u), r().createElement(a.Column, _K({
      noGutter: !0
    }, p), r().createElement(a.Button, _K({
      "data-testid": "form-submit"
    }, i, {
      type: "submit"
    }), t)));
  }, Fe[l.FORM_GROUP_BUTTONS] = function (e) {
    var t = e.callbacks,
      n = e.buttons,
      o = void 0 === n ? [] : n,
      l = e.rowProps,
      i = void 0 === l ? {} : l;
    return r().createElement(k, _W({
      center: "md"
    }, i), o.map(function (e, n) {
      var o = e.label,
        l = e.btnProps,
        i = void 0 === l ? {} : l,
        c = e.columnProps,
        u = void 0 === c ? {} : c,
        s = e.events,
        p = void 0 === s ? {} : s,
        d = Object.keys(p).reduce(function (e, n) {
          return e[n] = t[p[n]], e;
        }, {});
      return r().createElement(X, _W({
        key: n,
        noGutter: !0
      }, u), r().createElement(a.Button, _W({
        "data-testid": "form-group-btn-".concat(n),
        type: "button"
      }, i, d), o));
    }));
  }, Fe[l.FORM_OBSERVER] = J, Fe[l.FORM_GROUP_SELECTORS] = function (e) {
    var t = e.columnProps,
      l = e.selectorsList,
      i = void 0 === l ? [] : l,
      c = e.events,
      u = void 0 === c ? {} : c,
      s = e.callbacks,
      f = void 0 === s ? {} : s,
      m = function (e, t) {
        var n = {};
        for (var r in e) {
          Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
        }
        if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
          var o = 0;
          for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) {
            t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
          }
        }
        return n;
      }(e, ["columnProps", "selectorsList", "events", "callbacks"]),
      v = (0, o.useFormikContext)(),
      y = m.name,
      O = m.miniListConfig,
      b = p(u, f),
      g = O || {},
      h = g.miniListCount,
      E = void 0 === h ? 0 : h,
      P = g.miniListTooggle,
      x = void 0 !== P && P,
      I = g.miniListLabels,
      w = i.length - E,
      F = (0, n.useState)(x),
      j = F[0],
      k = F[1];
    return r().createElement(n.Fragment, null, r().createElement(o.Field, {
      name: y,
      id: y,
      type: "number"
    }, function (e) {
      var n = e.form,
        o = e.meta,
        l = e.field;
      return r().createElement("div", null, r().createElement(C, null, (i || []).map(function (e, o) {
        return E > 0 && o >= E && !j ? null : r().createElement(a.Column, _Z({}, t, {
          key: "formRadioSelector_".concat(o)
        }), r().createElement(a.Selector, {
          alignment: "row",
          selected: l.value === o,
          disabled: !1,
          onClick: function onClick() {
            n.setFieldValue(y, o), d(b, "onSelectionChange", {
              name: y,
              value: o,
              setFieldValue: v.setFieldValue,
              formikContext: v
            });
          },
          endContent: e.endContent
        }, r().createElement(a.Selector.Body, {
          title: e.title,
          subtitle: e.subtitle,
          align: "start"
        })));
      })), o.touched && o.error ? r().createElement(a.Spacing, {
        topBottom: 1
      }, r().createElement(D, null, o.error)) : null);
    }), O && w > 0 && r().createElement(a.Spacing, {
      topBottom: 1
    }, r().createElement(a.TextLink, {
      type: "link",
      onClick: function onClick() {
        return k(!j);
      }
    }, j ? I.minimize : "".concat(I.maximize, " (").concat(w, ")"))));
  }, Fe[l.FORM_CUSTOM_FIELD] = function (e) {
    var t = e.columnProps,
      a = e.events,
      l = void 0 === a ? {} : a,
      i = e.callbacks,
      c = void 0 === i ? {} : i,
      u = e.customComponents,
      s = void 0 === u ? {} : u,
      f = e.fieldRenderer,
      m = function (e, t) {
        var n = {};
        for (var r in e) {
          Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
        }
        if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
          var o = 0;
          for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) {
            t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
          }
        }
        return n;
      }(e, ["columnProps", "events", "callbacks", "customComponents", "fieldRenderer"]),
      v = m.name,
      y = p(l, c),
      O = s[f];
    return O ? r().createElement(n.Fragment, null, r().createElement(o.Field, {
      name: v,
      validate: function validate(e) {
        return d(y, "onValidateCustomField", {
          name: v,
          value: e
        });
      }
    }, function (e) {
      var n = e.field,
        o = e.meta,
        a = e.form;
      return r().createElement("div", {
        "data-testid": "custom-component-".concat(v)
      }, r().createElement(C, null, r().createElement(re, _ne({}, t), r().createElement(O, _ne({}, m, {
        field: n,
        eventProps: y,
        form: a,
        meta: o
      })))), o.touched && o.error && "string" == typeof o.error && r().createElement(D, {
        className: "error"
      }, o.error));
    })) : null;
  }, Fe[l.FORM_SWITCH] = function (e) {
    var t = e.label,
      n = e.columnProps,
      l = e.events,
      i = void 0 === l ? {} : l,
      c = e.callbacks,
      u = void 0 === c ? {} : c,
      s = function (e, t) {
        var n = {};
        for (var r in e) {
          Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
        }
        if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
          var o = 0;
          for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) {
            t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
          }
        }
        return n;
      }(e, ["label", "columnProps", "events", "callbacks"]),
      f = (0, o.useFormikContext)(),
      m = p(i, u),
      v = (0, o.useField)(s),
      y = v[0],
      O = v[1],
      b = v[2].setValue;
    return r().createElement(a.Column, _le({}, n), r().createElement(a.Layout.Inline, {
      alignY: "center"
    }, r().createElement(a.Text, {
      type: "smallBody"
    }, t), r().createElement(a.Toggle, {
      defaultValue: O.initialValue,
      value: y.value,
      onChange: function onChange(e) {
        var t = e.target.checked;
        b(t), d(m, "onSelectionChange", {
          name: s.name,
          value: t,
          setFieldValue: f.setFieldValue,
          formikContext: f
        });
      }
    })));
  }, Fe[l.FORM_GROUP_INPUTS] = fe, Fe[l.FORM_FIELD_ARRAY] = function (e) {
    var t,
      i = (0, n.useState)(0),
      c = i[0],
      u = i[1],
      s = (0, o.useField)(e),
      d = s[0],
      f = s[1],
      m = e.groupElements,
      v = e.customComponents,
      y = e.titleProps,
      O = e.additionalContentProps,
      b = e.footerProps,
      g = e.events,
      h = void 0 === g ? {} : g,
      E = e.fieldsWrapper,
      P = e.variant,
      x = void 0 === P ? "accordion" : P,
      I = ge(e, ["groupElements", "customComponents", "titleProps", "additionalContentProps", "footerProps", "events", "fieldsWrapper", "variant"]),
      w = function w(e, t) {
        u(c === t ? -1 : t);
      };
    (0, n.useEffect)(function () {
      var t,
        n = null !== (t = e.defaultIndex) && void 0 !== t ? t : d.value.length - 1;
      u(n);
    }, [null === (t = d.value) || void 0 === t ? void 0 : t.length, e.defaultIndex]);
    var F = p(h, e.callbacks),
      j = v[null == y ? void 0 : y.fieldRenderer] || je[l.EMPTY_FIELD],
      C = v[null == O ? void 0 : O.fieldRenderer] || je[l.EMPTY_FIELD],
      k = v[null == b ? void 0 : b.fieldRenderer] || je[l.EMPTY_FIELD],
      _ = m;
    return r().createElement(o.FieldArray, {
      name: e.name
    }, function (t) {
      var n = t.form,
        o = ge(t, ["form"]);
      return r().createElement(Pe, null, d.value.map(function (t, l) {
        _ = Ee({
          config: e.groupElements,
          parentIndex: l,
          parentFieldName: d.name
        });
        var i = (I || {}).callbacks,
          u = _be({}, I);
        return (null == i ? void 0 : i.onDemandDataSource) && (u = _be(_be({}, I), {
          data: null == i ? void 0 : i.onDemandDataSource(I.data, l)
        })), r().createElement(r().Fragment, null, r().createElement(he, {
          type: E,
          keyIndex: l
        }, r().createElement(r().Fragment, null, "accordion" === x && r().createElement(a.Accordion, {
          dividerNeeded: !1,
          value: l,
          selected: c === l,
          onClick: w,
          title: r().createElement(j, {
            index: l,
            eventProps: F,
            helpers: o,
            form: n,
            field: d,
            meta: f
          }),
          desc: r().createElement(fe, _be({
            groupElements: _,
            customComponents: v,
            events: h,
            index: l
          }, u))
        }), "section" === x && r().createElement(r().Fragment, null, r().createElement(j, {
          index: l,
          eventProps: F,
          helpers: o,
          form: n,
          field: d,
          meta: f
        }), r().createElement(fe, _be({
          groupElements: _,
          customComponents: v,
          events: h,
          index: l
        }, u))))), r().createElement(C, {
          fieldIndex: l
        }));
      }), r().createElement(k, {
        helpers: o,
        eventProps: F,
        form: n,
        field: d,
        meta: f,
        groupElements: _
      }));
    });
  }, Fe[l.EMPTY_FIELD] = function () {
    return null;
  }, Fe);
  var _Ce = function Ce() {
      return _Ce = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }
        return e;
      }, _Ce.apply(this, arguments);
    },
    ke = function ke(e) {
      var t = e.data,
        n = e.callbacks,
        o = e.component,
        a = e.dataSource,
        i = e.keyIndex,
        c = e.inputWrapProps,
        u = e.customComponents,
        s = function (e, t) {
          var n = {};
          for (var r in e) {
            Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
          }
          if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
            var o = 0;
            for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) {
              t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
            }
          }
          return n;
        }(e, ["data", "callbacks", "component", "dataSource", "keyIndex", "inputWrapProps", "customComponents"]),
        p = o === l.FORM_GROUP_INPUTS || o === l.FORM_FIELD_ARRAY ? {
          data: t,
          dataSource: a
        } : {
          source: t[a]
        },
        d = _Ce(_Ce(_Ce(_Ce(_Ce({}, s), n ? {
          callbacks: n
        } : {}), p ? _Ce({}, p) : {}), i ? {
          key: i
        } : {}), u ? {
          customComponents: u
        } : {}),
        f = je[o] || je[l.EMPTY_FIELD];
      return c ? r().createElement(_, _Ce({}, c), r().createElement(f, _Ce({}, d))) : r().createElement(f, _Ce({}, d));
    };
  var _e = function _e(e) {
    var t = (0, n.useRef)({}),
      i = e.data,
      c = e.stackSpacing,
      u = void 0 === c ? 3 : c,
      p = e.enableReinitialize,
      d = void 0 === p || p,
      f = e.initialValues,
      m = e.onSubmit,
      v = e.onValidate,
      y = e.onValueChange,
      b = e.formFieldsConfig,
      g = e.validationSchema,
      h = e.enableInputErrorFocus,
      E = void 0 !== h && h,
      P = e.callbacks,
      x = void 0 === P ? {} : P,
      I = e.valuesChangeOnDemand,
      w = e.errorsOnDemand,
      F = e.dynamicFieldProps,
      j = e.components,
      C = e.innerRef,
      k = (0, n.useState)(O(b, g, x, {}, {}, t.current)),
      _ = k[0],
      T = k[1];
    (0, n.useEffect)(function () {
      T(O(b, g, x, {}, {}, t.current));
    }, [b, g]);
    var S = (0, n.useCallback)(function (e) {
        var t = e.values,
          n = e.prevValues,
          r = e.errors,
          o = e.formikContext;
        y && y(t, n, L(o)), T(O(b, g, x, n, r, o));
      }, [b, g]),
      R = _Ce({
        validationSchema: _,
        enableReinitialize: d,
        initialValues: f,
        onSubmit: m,
        dynamicFieldProps: F,
        innerRef: C
      }, v ? {
        validate: v
      } : {}),
      M = (0, n.useMemo)(function () {
        return function (e) {
          var t = function t(e) {
            return e.component === l.FORM_TITLE && e.hasSectionNumbering;
          };
          if (e.filter(t).length < 2) return e;
          var n = 0;
          return e.map(function (e) {
            return t(e) ? _s(_s({}, e), {
              title: "".concat(++n, ". ").concat(e.title)
            }) : e;
          });
        }(b);
      }, [b]),
      L = function L(e) {
        return function (t) {
          var n = e.getFieldMeta(t);
          return !((null == e ? void 0 : e.isValidating) || (null == n ? void 0 : n.error));
        };
      };
    return Array.isArray(b) && b.length ? r().createElement(o.Formik, _Ce({}, R), function (e) {
      var n = e.handleSubmit;
      return t.current = e, r().createElement("form", {
        onSubmit: n
      }, r().createElement(a.Layout.Stack, {
        space: u
      }, M.map(function (e, t) {
        var n = _Ce({
          callbacks: x,
          data: i,
          customComponents: j
        }, e);
        return r().createElement(ke, _Ce({
          key: "form-field".concat(t),
          keyIndex: "form-rendering-".concat(t)
        }, n, {
          dynamicFieldProps: F
        }));
      }), r().createElement(J, {
        errorsOnDemand: w,
        onChange: S,
        valuesOnDemand: I,
        enableInputErrorFocus: E
      })));
    }) : r().createElement("div", null, "Field configs is required to build the form.");
  };
  var Te = function Te(e, t) {
      e.forEach(function (e) {
        e.groupElements ? Te(e.groupElements, t) : t(e.name);
      });
    },
    Se = exports;
  for (var Re in t) {
    Se[Re] = t[Re];
  }
  t.__esModule && Object.defineProperty(Se, "__esModule", {
    value: !0
  });
})();